<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedRatings.length" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ title }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium.capitalize {{ getSelectedRatings() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ title }}
    
    .white
      .font-semibold.text-sm.px-4.pt-4.pb-2 {{ $t('filter_by') }} {{ title.toLowerCase() }}
      div.pt-1.pb-4
        template(v-for="option in options")
          .d-flex.text-sm.py-2.px-4
            yc-checkbox(:input-value="isChecked(option)" @change="clickItem(option)")
            .ml-4.clickable(@click="clickItem(option)") {{ option }} star

    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="selectedRatings.length" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    title: {
      type: String,
      default: 'Rating'
    },
    param: {
      type: String,
      default: 'review_star'
    },
    options: {
      type: Array,
      default: (() => [])
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showMenu: false,
    ratings: [],
    selectedRatings: []
  }),
  computed: {
    disabledButton () {
      return this.ratings.length === 0
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedRatings = this.filter.value.split(',')
          this.ratings = this.filter.value.split(',')
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.ratings = []
      this.selectedRatings = []
    },
    apply () {
      this.showMenu = false
      this.selectedRatings = [...this.ratings]
      let filter = { key: this.param, value: this.ratings.join(',') }
      this.$emit('update:filter', filter)
    },
    getSelectedRatings () {
      return this.selectedRatings.join(', ')
    },
    clickItem (item) {
      if (this.ratings.includes(item)) {
        this.ratings = this.ratings.filter(f => f !== item)
      } else {
        this.ratings.push(item)
      }
    },
    isChecked (value) {
      return Boolean(this.ratings.find(item => item === value))
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
</style>